import { Link, LinkProps } from "@tanstack/react-router"
import { CSSProperties, Image, ImageProps } from "@mantine/core"

interface Props extends LinkProps {
  src: string
  imageProps?: ImageProps
  style?: CSSProperties
}

export function ImageLink({ imageProps, src, ...linkProps }: Props) {
  return (
    <Link {...linkProps}>
      <Image src={src} {...imageProps} />
    </Link>
  )
}
